import React from "react";
import { cn } from "./utils";

const variants = {
  default: "border-slate-200 bg-white text-slate-700 hover:bg-slate-50",
  ghost: "border-transparent bg-transparent text-slate-700 hover:bg-slate-100",
  danger: "border-red-200 bg-white text-red-600 hover:bg-red-50"
};

const sizes = {
  sm: "h-8 w-8",
  md: "h-10 w-10",
  lg: "h-11 w-11"
};

export const IconButton = React.forwardRef(({
  "aria-label": ariaLabel,
  children,
  className,
  icon: Icon,
  size = "md",
  type = "button",
  variant = "default",
  ...props
}, ref) => (
  <button
    ref={ref}
    type={type}
    aria-label={ariaLabel}
    title={props.title || ariaLabel}
    className={cn(
      "inline-flex shrink-0 items-center justify-center rounded-md border transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-300 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-60",
      variants[variant] || variants.default,
      sizes[size] || sizes.md,
      className
    )}
    {...props}
  >
    {Icon ? <Icon className="h-4 w-4" aria-hidden="true" /> : children}
  </button>
));

IconButton.displayName = "IconButton";

export default IconButton;
